/**
 * Whether to automatically bind DOM attributes for analytics tracking
 *
 * @type boolean
 */
export const AUTO_BIND = true;

/**
 * Whether to automatically embed third-party analytics scripts (GA, Meta, Reddit)
 *
 * @type boolean
 */
export const AUTO_EMBED = false;

/**
 * Default debounce interval in milliseconds for analytics events
 *
 * @type number
 */
export const DEFAULT_DEBOUNCE = 0;

/**
 * Default time-to-live in milliseconds for analytics events
 *
 * @type number
 */
export const DEFAULT_TTL = 0;

/**
 * Google Analytics measurement ID
 *
 * @type string
 */
export const GOOGLE_ID = process.env.VUE_APP_GOOGLE_ANALYTICS_ID || 'G-J5935ST4H4';

/**
 * Whether to mask email addresses in analytics data
 *
 * @type boolean
 */
export const MASK_EMAILS = true;

/**
 * Whether to mask phone numbers in analytics data
 *
 * @type boolean
 */
export const MASK_PHONES = true;

/**
 * Whether to respect the browser's Do Not Track setting
 *
 * @type boolean
 */
export const RESPECT_DNT = true;

/**
 * Sampling rate for analytics events (0 to 1)
 *
 * @type number
 */
export const SAMPLE_RATE = 1;

/**
 * Whether to scrub personally identifiable information from analytics data
 *
 * @type boolean
 */
export const SCRUB_PII = true;
